import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import type { BaseQueryFn, FetchArgs, FetchBaseQueryError } from '@reduxjs/toolkit/query';
import type { RootState } from 'store/create-store';
import { ENV_CONFIG } from 'config/environment';
import { getAccessToken } from 'services/storage';

const rawBaseQuery = fetchBaseQuery({
  baseUrl: ENV_CONFIG().API.BASE_URL,
  prepareHeaders: (headers, { getState }) => {
    const state = getState() as RootState;
    const token = state.user?.token || getAccessToken();

    if (token) {
      headers.set('Authorization', `Bearer ${token}`);
    }

    headers.set('Content-Type', 'application/json');
    headers.set('Access-Control-Allow-Origin', '*');
    headers.set('X-Auth-Version', 'v2');

    return headers;
  },
});

export const baseQueryWithAuth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> = (
  args,
  api,
  extraOptions
) => {
  const state = api.getState() as RootState;
  const activeRole = state.admins?.activeRole;

  const normalized: FetchArgs = typeof args === 'string' ? { url: args } : args;

  const argsWithRole: FetchArgs = activeRole
    ? { ...normalized, params: { ...normalized.params, active_role: activeRole } }
    : normalized;

  return rawBaseQuery(argsWithRole, api, extraOptions);
};
